import slider_main from '../images/slider_main.jpg'


export const images = [slider_main]

const imageByIndex = (index) => images[index % images.length]

export default imageByIndex
